import React, { useState } from "react";
import { doReportPractice } from "../../GestisciPraticheSlice";
import { useDispatch } from "react-redux";
import CoreButtonHoverIcon from "../../../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import CoreModal from "../../../../../app/core/components/CoreModal/CoreModal";
import CreaPratichePage from "../../CreaPratichePage/CreaPratichePage";
import { toast } from "react-toastify";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import { t } from "i18next";

const GestisciPraticaButtonCockpit = ({ onRefetch }) => {
  const [openModal, setOpenModal] = useState(false);

  //HOOKS
  const dispatch = useDispatch();

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleDownload = () => {
    toast.info(t("HandleDownload"));
    dispatch(doReportPractice());
  };

  return (
    <div className="flex space-x-4">
      <CoreButtonHoverIcon
        onClick={onRefetch}
        className="text-blue-500 m-1 flex flex-row space-x-2 border"
        testo={t("Refresh")}
        icon={<RefreshRoundedIcon className={`fill-blue-500`} />}
      />
      <CoreButtonHoverIcon
        onClick={handleOpenModal}
        className="text-blue-700 m-1"
        icon={<AddBoxRoundedIcon className={`fill-blue-700 `} />}
        testo={t("Practice")}
      />

      <CoreButtonHoverIcon
        onClick={handleDownload}
        className="text-darkgray  m-1"
        icon={<DownloadRoundedIcon className={`fill-darkgray`} />}
        testo={"Report"}
      />

      <CoreModal
        component={<CreaPratichePage closeModal={handleCloseModal} />}
        state={openModal}
        onClose={handleCloseModal}
        width={1000}
        maxHeight={800}
      />
    </div>
  );
};

export default GestisciPraticaButtonCockpit;
